export const name = "MOD";
export const summary = `Gets the remainder of the division of \`X\` by \`Y\`.`;
export const reference = `
## MOD

Gets the remainder of the division of \`X\` by \`Y\`.

\`\`\`
MOD(X, Y)
\`\`\`

### Description

Modulo function: returns the remainder of the division of X by Y. Returned value has the same sign as X. An error is generated if Y is 0.

| X | Y | MOD(X, Y) |
| --- | --- | --- |
| 25 | 12 | 1 |
| 25 | 0 | Error |


### Return Data Type

The return data type is determined by the argument types with the following table.

















| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` |
| --- | --- | --- | --- |
| \`INT64\` | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` |
| \`NUMERIC\` | \`NUMERIC\` | \`NUMERIC\` | \`BIGNUMERIC\` |
| \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` |




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
